import React from 'react';
import { SmBadge } from '@smiles/smiles-react-design-system';

import {
  TInfo,
  TRecommendation,
} from '@/services/requests/Recommendation/types/template5';

import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  data: TRecommendation;
};

const getBadgeVariant = (theme: TInfo['theme']) => {
  if (theme === 'clube') {
    return 'club';
  }

  if (theme === 'diamante') {
    return 'neutral';
  }

  return undefined;
};

export const CardInfo = ({ data }: TProps) => {
  const { text, info, extra_info } = data;
  const imageUrl = getValue(data, 'image.image.url', '');
  const infoText = getValue(data, 'info.text', '');
  const extraInfoText = getValue(data, 'extra_info.text', '');
  if ((!text && !imageUrl) || !info) return null;

  return (
    <div className="vitrine-template5__cardinfo">
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          className="vitrine-template5__cardinfo__image"
        />
      )}
      <span className="vitrine-template5__cardinfo__title">{text}</span>
      <div className="vitrine-template5__cardinfo__tagbox">
        {infoText && (
          <SmBadge
            text={infoText}
            className="vitrine-template5__cardinfo__badge"
            variant={getBadgeVariant(info.theme)}
          />
        )}
        {extra_info && extraInfoText && (
          <SmBadge
            text={extraInfoText}
            className="vitrine-template5__cardinfo__badge"
            variant={getBadgeVariant(extra_info.theme)}
          />
        )}
      </div>
    </div>
  );
};
